var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-driven-transition',{attrs:{"isNext":_vm.isNext}},[(_vm.active)?_c('div',{key:_vm.fieldId,class:['field-group','field_'+_vm.fieldId]},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }